const Djelatnik = function(DS) {
    return DS.defineResource({
        name: 'Djelatnik',
        endpoint: '/djelatnici'
    });
};

Djelatnik.$inject = ['DS'];

export {Djelatnik};



// WEBPACK FOOTER //
// ./app/models/djelatnik.js